import { useLocation } from "@reach/router";
import { useMemo } from "react";
import getEventEndTime from "./getEventEndTimeFromConfig";
import registrationOnlyMode from "./registrationOnlyMode";

const useEventDetails = () => {
  const { pathname } = useLocation();
  const registrationOnly = registrationOnlyMode();

  // Exported Variables
  const virtual = pathname.includes("virtual");
  const agenda = pathname.includes("agenda");
  const techExpo = pathname.includes("tech-expo");
  const startDate = new Date(process.env.GATSBY_EVENT_START_TIME || Date.now());
  const endDate = new Date(process.env.GATSBY_EVENT_END_TIME || Date.now());
  const eventEndTime = getEventEndTime().getTime();
  const isAfterEvent = useMemo(() => Date.now() > endDate.getTime(), []);
  const isBeforeEvent = useMemo(() => startDate.getTime() > Date.now(), []);
  const isDuringEvent = useMemo(() => !isBeforeEvent && !isAfterEvent, []);
  const showLogin = virtual && !registrationOnly;

  // Exported Functions
  const usDateToMachineDate = (dateStr: string): Date => {
    let [month, day, year] = dateStr.split("/").map((num) => {
      if (num.length === 1) {
        return "0" + num;
      } else {
        return num;
      }
    });

    const newDate = new Date(`${year}-${month}-${day}T00:00:00-04:00`);

    // Not using the time, just the date, but making sure it's right
    return newDate;
  };

  return {
    agenda,
    virtual,
    startDate,
    endDate,
    techExpo,
    eventEndTime,
    isBeforeEvent,
    isDuringEvent,
    isAfterEvent,
    registrationOnly,
    showLogin,
    usDateToMachineDate,
  };
};

export default useEventDetails;
